import { render } from "./stats-card.vue?vue&type=template&id=4000f4fa&ts=true"
import script from "./stats-card.vue?vue&type=script&lang=ts"
export * from "./stats-card.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__